const styles = {
  container: {
    marginBottom: '20px',
  },
  title: {
    marginTop: '0',
    marginBottom: '15px',
    color: '#495057',
    fontSize: '18px',
    textAlign: 'left'
  },
  tokensGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(56px, 1fr))',
    gap: '10px'
  },
  tokenButton: {
    padding: '0',
    border: '0',
    cursor: 'pointer',
    transition: 'all 0.2s',
    backgroundColor: 'transparent',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '56px'
  },
  tokenContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    width: '100%'
  },
  tokenImage: {
    width: '40px',
    height: '40px',
    objectFit: 'contain'
  },
  selectedImg: {
    width: '56px',
    height: '56px',
    objectFit: 'contain',
    position: 'absolute',
    transform: 'translateY(-8px)'
  },
  colorFallback: {
    width: '40px',
    height: '40px',
    borderRadius: '4px'
  },
  tokenLabel: {
    fontSize: '12px',
    color: '#495057',
    textAlign: 'center',
    wordBreak: 'break-word'
  }
};

export default styles;